import { render, staticRenderFns } from "./ShopRouter_my_pc.vue?vue&type=template&id=0a7b274a&scoped=true"
import script from "./ShopRouter_my_pc.vue?vue&type=script&lang=js"
export * from "./ShopRouter_my_pc.vue?vue&type=script&lang=js"
import style0 from "./ShopRouter_my_pc.vue?vue&type=style&index=0&id=0a7b274a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a7b274a",
  null
  
)

export default component.exports